import React, { Fragment, useContext, useState } from "react";
/// React router dom
import { Link } from "react-router-dom";
import { ThemeContext } from "../../../context/ThemeContext";
import logo from "../../../assets/images/logo-satti.png";
export function NavMenuToggle() {
  setTimeout(() => {
    let mainwrapper = document.querySelector("#main-wrapper");
    if (mainwrapper.classList.contains("menu-toggle")) {
      mainwrapper.classList.remove("menu-toggle");
    } else {
      mainwrapper.classList.add("menu-toggle");
    }
  }, 200);
}

// Unconditionally closes the mobile (overlay) sidebar — used after a nav
// link is picked so it doesn't stay open covering the page it just opened.
export function closeMobileMenu() {
  document.querySelector("#main-wrapper")?.classList.remove("menu-toggle");
}

const NavHader = () => {
  const [toggle, setToggle] = useState(false);
  const { navigationHader, openMenuToggle, background } =
    useContext(ThemeContext);
  return (
    <div className="nav-header">
      <Link to="/dashboard" className="brand-logo">
        <>
          <Fragment>
            <img
              height={"100%"}
              width={"100%"}
              style={{
                objectFit: "contain",
                height: "100%",
                width: "100%",
                padding: "5px",
              }}
              src={logo}
              alt=""
            />
          </Fragment>
        </>
      </Link>

      <div
        className="nav-control"
        onClick={() => {
          setToggle(!toggle);
          openMenuToggle();
          NavMenuToggle();
        }}
      >
        <div className={`hamburger ${toggle ? "is-active" : ""}`}>
          <span className="line"></span>
          <span className="line"></span>
          <span className="line"></span>
        </div>
      </div>
    </div>
  );
};

export default NavHader;
